import { takeLatest, call, put } from 'redux-saga/effects';
import { getMasterDataSuccess, getMasterDataFailure, postPatientRegistrationSuccess, postPatientRegistrationFailure, getPatientInformationSuccess, getPatientInformationFailure, deletePatientInformationSuccess, deletePatientInformationFailure, putPatientInformationSuccess, putPatientInformationFailure } from './slice';
import { apiGet, apiPost, apiPut, apiDelete, apiUpload } from '../../../../api/client';
import { updatePatientImagingAttachement } from '../../../../utils/api';
function* getMasterDataRequest() {
    try {
const response = yield call(apiGet, 'api/get-registration-masterData');
        yield put(getMasterDataSuccess(response));
    } catch (error) {
        yield put(getMasterDataFailure(error?.response?.message || error));
    }
}
function* postPatientRegistrationRequest(action) {
    try {
        const response = yield call(apiPost, 'api/post-patient-registration', action.payload);
        const fileUploadRes = yield call(updatePatientImagingAttachement, action.payload.fileFormData, response.pId);
        if(fileUploadRes?.data?.medicalHistory?.imagingStudies){
            response.patientdata.medicalHistory.imagingStudies = fileUploadRes?.data?.medicalHistory?.imagingStudies
        }
        yield put(postPatientRegistrationSuccess(response));
    } catch (error) {
        yield put(postPatientRegistrationFailure(error?.response?.message || error));
    }
}



function* getPatientInformationRequest(action) {
    try {
        const { currentBranch, limit, skip, search, searchType } = action.payload;
        const qs = new URLSearchParams({
            limit: limit ?? '',
            skip: skip ?? '',
            search: search ?? '',
            searchType: searchType ?? '',
        }).toString();
        const response = yield call(apiGet, `api/get-patient-information/${currentBranch}?${qs}`);
        yield put(getPatientInformationSuccess(response));
    } catch (error) {
        yield put(getPatientInformationFailure(error?.body?.message || error?.message));
    }
}

function* deletePatientInformationRequest(action) {
    try {
        const response = yield call(apiDelete, `api/delete-patient-information/${action.payload}`);
        yield put(deletePatientInformationSuccess(response));
    } catch (error) {
        yield put(deletePatientInformationFailure(error?.response?.message || error));
    }
}

function* putPatientInformationRequest(action) {
    try {
        const response = yield call(apiPut, `api/edit-patient-information/${action.payload._id}`, action.payload.formData);
        yield put(putPatientInformationSuccess(response));
    } catch (error) {
        yield put(putPatientInformationFailure(error?.response?.message || error));
    }
}


function* saga() {
    yield takeLatest('patientRegistration/getMasterDataRequest', getMasterDataRequest);
    yield takeLatest('patientRegistration/postPatientRegistrationRequest', postPatientRegistrationRequest);
    yield takeLatest('patientRegistration/getPatientInformationRequest', getPatientInformationRequest);
    yield takeLatest('patientRegistration/deletePatientInformationRequest', deletePatientInformationRequest);
    yield takeLatest('patientRegistration/putPatientInformationRequest', putPatientInformationRequest);
}

export default saga;